import { Site } from "@libry-content/types";
import { getDocumentId } from "./getDocumentId";
import { sanityConfig } from "./sanityConfig";

export const getSiteAccessResourcesNames = (site: Pick<Site, "_id" | "name" | "defaultLanguage">) => {
  const dataset = sanityConfig.dataset;

  const siteId = getDocumentId(site);

  return {
    allDocumentsPermission: `${dataset}_content_${siteId}`,
    editorRole: `${dataset}_editor_${siteId}`,
  };
};
